import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.375 7.5L9.30662 10.7877C9.7265 11.0677 10.2735 11.0677 10.6934 10.7877L15.625 7.5M5.625 14.375H14.375C15.0654 14.375 15.625 13.8154 15.625 13.125V6.875C15.625 6.18464 15.0654 5.625 14.375 5.625H5.625C4.93464 5.625 4.375 6.18464 4.375 6.875V13.125C4.375 13.8154 4.93464 14.375 5.625 14.375Z",
  stroke: "white",
  "stroke-width": "0.9375",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

interface Props {
    backgroundFill?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GreenMailIcon',
  props: {
    backgroundFill: { default: "#0D9488" }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("rect", {
      width: "20",
      height: "20",
      rx: "5",
      fill: _ctx.backgroundFill
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})